import {
  collection,
  onSnapshot,
  orderBy,
  query,
  type Unsubscribe,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import {
  CALLABLE_FUNCTIONS,
  type IceCandidateInitLite,
  type PostSessionSignalRequest,
  type PostSessionSignalResponse,
  type SessionSignalDocument,
  type SignalingKind,
} from "@srd/shared";
import { db, functions } from "../firebase";

export function subscribeSessionSignaling(
  sessionId: string,
  onMessage: (doc: SessionSignalDocument) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  const q = query(
    collection(db, "sessions", sessionId, "signaling"),
    orderBy("createdAt", "asc"),
  );
  const seen = new Set<string>();
  return onSnapshot(
    q,
    (snap) => {
      for (const change of snap.docChanges()) {
        if (change.type !== "added") continue;
        const data = change.doc.data() as SessionSignalDocument;
        const id = data.messageId || change.doc.id;
        if (seen.has(id)) continue;
        seen.add(id);
        if (data.fromRole === "technician") continue;
        onMessage(data);
      }
    },
    (err) => onError?.(err),
  );
}

export async function postSignal(params: {
  sessionId: string;
  sessionJwt?: string;
  kind: SignalingKind;
  sdp?: string;
  candidate?: IceCandidateInitLite;
}): Promise<PostSessionSignalResponse> {
  const callable = httpsCallable<PostSessionSignalRequest, PostSessionSignalResponse>(
    functions,
    CALLABLE_FUNCTIONS.postSessionSignal,
  );
  const result = await callable(params);
  return result.data;
}
